import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { CheckBox } from "../core/components/checkBox";
import { BaseField } from "../core/components/baseComponentProps";
import React from "react";
export default class PageBox extends React.Component<PageBoxProps, PageBoxState> {
    private factory = ComponentHelper.createFactory();
    private lastValue: number;
    constructor(props: PageBoxProps) {
        super(props);
        this.state = {
            value: Helper.isNumber(props.value) ? props.value : null,
            lastPage: (Helper.hasValue(props.value)) && (Helper.isNumber(props.value)) && (props.value == -1)
        }
        this.lastValue = this.state.value;
    }

    private setValue = (value: number) => {
        if(value !== -1)
            this.lastValue = value;
        this.setState({ value: value, lastPage: ((Helper.hasValue(value)) && (Helper.isNumber(value)) && (value === -1)) }, () => { this.props.onChange(this.props.field, value) });
    }


    private createNumericTextBox = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.value;
        props.disabled = this.props.disabled;
        props.field.min = 0;
        props.field.spinners = true
        props.onChange = (field, value: number) => {
            this.setValue(value)
        }

        return (
            <div style={{ flexGrow: 100, display: this.state.lastPage ? "none" : "block" }}>
                <IsNumericTextBox {...props} />
            </div>
        );
    }

    private createCheckBox = () => {
        let props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.lastPage;
        props.disabled = this.props.disabled;
        props.onChange = (field, checked: boolean) => {
            if (checked) {
                this.setValue(-1);
            } else {
                this.setValue(this.lastValue == -1 ? null : this.lastValue);
            }
        }

        let display = "flex";
        if (this.props.disabled && !this.state.lastPage) {
            display = "none";
        }

        return (
            <div style={{ width: this.props.disabled ? "0%" : "auto", display: display, alignItems: "baseline", maxWidth: "50%" }}>
                <div style={{ marginRight: "5px" }}>
                    {this.props.context.translations["WebSMS.ReportMetadata.LastPage"]}
                </div>
                <div style={{ marginLeft: this.props.disabled ? "50px" : "0", marginRight: "10px" }}>
                    <CheckBox {...props} />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div style={{ display: "flex" }}>
                {this.createCheckBox()}
                {this.createNumericTextBox()}
            </div>
        );
    }
}

interface PageBoxProps {
    field: BaseField;
    value: number;
    onChange: (field, value) => void;
    disabled: boolean;
    context: {
        translations: {}
    }
}

interface PageBoxState {
    lastPage: boolean;
    value: number;
}